import { render, staticRenderFns } from "./TestAnswers.vue?vue&type=template&id=21a1c45e&scoped=true&"
import script from "./TestAnswers.vue?vue&type=script&lang=js&"
export * from "./TestAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a1c45e",
  null
  
)

export default component.exports